import { render, staticRenderFns } from "./AvailableBalanceModal.vue?vue&type=template&id=6cc022f2&scoped=true&"
import script from "./AvailableBalanceModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AvailableBalanceModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AvailableBalanceModal.vue?vue&type=style&index=0&id=6cc022f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc022f2",
  null
  
)

export default component.exports